module.exports = __webpack_public_path__ + "assets/img/ja-209a1f35.png";